/**
 * Arrow controls for the horizontal card carousels.
 *
 * The scrolling itself is native CSS overflow with scroll-snap; this only adds
 * the buttons, so the carousel still works with JavaScript disabled or while
 * the script is loading. Buttons hide themselves when there is nothing to
 * scroll, which is the case at desktop widths where the cards form a grid.
 */
(() => {
  const sync = (track, prev, next) => {
    const scrollable = track.scrollWidth - track.clientWidth > 4;
    const nav = prev.parentElement;
    nav.hidden = !scrollable;
    if (!scrollable) return;

    const atStart = track.scrollLeft <= 4;
    const atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    prev.disabled = atStart;
    next.disabled = atEnd;
  };

  const step = (track) => {
    const card = track.querySelector(':scope > *');
    if (!card) return track.clientWidth * 0.8;
    const gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
    return card.getBoundingClientRect().width + gap;
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-mdc-carousel]').forEach((wrapper) => {
      const track = wrapper.querySelector('[data-mdc-carousel-track]');
      const prev = wrapper.querySelector('[data-mdc-carousel-prev]');
      const next = wrapper.querySelector('[data-mdc-carousel-next]');
      if (!track || !prev || !next || track.dataset.carouselReady) return;
      track.dataset.carouselReady = 'true';

      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      prev.addEventListener('click', () => track.scrollBy({ left: -step(track), behavior }));
      next.addEventListener('click', () => track.scrollBy({ left: step(track), behavior }));

      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => sync(track, prev, next));
      }, { passive: true });

      new ResizeObserver(() => sync(track, prev, next)).observe(track);
      sync(track, prev, next);
    });
  };

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
